export default __webpack_public_path__ + "static/media/team-5@2x.fb7e98fe.png";